import { Col, Icon, Row } from 'antd'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import { Flex } from '../styles/styled-common'
import { SortOrder, withoutProps } from '../utils'

const ListHeader = styled.div`
  text-align: center;
`

const SortIcon = styled(Icon)`
  font-size: 0.8em;
  transition: all 0.3s;
  position: relative;
  display: block;

  &.active {
    color: ${p => p.theme.antLink};
  }
`

const Sorter = styled.span`
  margin-left: 6px;
  margin-right: -10px;
  display: inline-block;
  font-weight: 400;
  color: #cecece;
  flex: 0 auto;

  > span {
    display: block;
    cursor: pointer;
    position: relative;
  }
`

const StRow = styled(Row)`
  padding: 0 20px;
  height: 100%;
`

const Title = styled.span`
  flex: 0 ${({ basis }) => (typeof basis !== 'undefined' ? basis : 'auto')};
`

const HeaderCell = ({ sortOrder, column, style, onClick }) => {
  if (!column.sorter) {
    return (
      <Col style={style} onClick={onClick} {...column.layout}>
        <Flex flexDirection="column" alignItems="stretch" fullWidth fullHeight>
          {column.title}
        </Flex>
      </Col>
    )
  }

  return (
    <Col
      {...column.layout}
      style={{ ...style, cursor: 'pointer' }}
      onClick={onClick}
    >
      <Flex
        flexDirection="row"
        alignItems="center"
        flexWrap="nowrap"
        fullWidth
        fullHeight
      >
        {/* flex-basis hack to make TrustPilot Ratings header cell width to behave nicely */}
        <Title basis={column.columnKey === 'ratings' ? 0 : 'auto'}>
          {column.title}
        </Title>
        <Sorter className="ant-table-column-sorter">
          <span>
            <SortIcon
              type="caret-up"
              className={sortOrder === SortOrder.ASC ? 'active' : ''}
            />
          </span>
          <span style={{ marginTop: -5 }}>
            <SortIcon
              type="caret-down"
              className={sortOrder === SortOrder.DESC ? 'active' : ''}
              style={{ marginTop: '.2em' }}
            />
          </span>
        </Sorter>
      </Flex>
    </Col>
  )
}

class HostsListHeader extends Component {
  static propTypes = {
    sortBy: PropTypes.string,
    sortOrder: PropTypes.oneOf([SortOrder.DESC, SortOrder.ASC]),
    onSortChange: PropTypes.func,
    columns: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        columnKey: PropTypes.string.isRequired,
        sorter: PropTypes.func,
      })
    ),
    affixed: PropTypes.bool,
  }

  _onSortClick = col => {
    this.props.onSortChange && this.props.onSortChange(col)
  }

  render() {
    return (
      <ListHeader {...withoutProps(this.props, HostsListHeader.propTypes)}>
        <StRow
          gutter={{ xs: 2, sm: 3, md: 3, lg: 8, xl: 20, xxl: 20 }}
          type="flex"
          justify="space-between"
        >
          {this.props.columns.map(col => (
            <HeaderCell
              key={col.columnKey}
              onClick={col.sorter && (() => this._onSortClick(col))}
              style={{ position: 'relative' }}
              column={col}
              sortOrder={
                this.props.sortBy === col.columnKey && this.props.sortOrder
              }
            />
          ))}
        </StRow>
      </ListHeader>
    )
  }
}

export default styled(HostsListHeader)`
  background: ${p => p.theme.offBlack};
  margin-bottom: 10px;
  height: 5em;
  border-radius: 6px;
  font-size: 0.8em;
  box-shadow: ${({ affixed }) =>
    affixed ? '0 7px 13px -5px #6cc0ff' : 'none'};
`



// WEBPACK FOOTER //
// /opt/build/repo/src/components/HostsListHeader.jsx